exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3tDv-VrE72--9I{margin-top:8px}._2RsLAlpqJ82N71{margin-bottom:16px}._2RsLAlpqJ82N71 svg{display:block;margin-bottom:16px}.mnn30oj78AN7V_{margin:0 0 8px 20px}", ""]);

// exports
exports.locals = {
	"contentSkeletonContainer": "_3tDv-VrE72--9I",
	"cardSkeleton": "_2RsLAlpqJ82N71",
	"titleSkeleton": "mnn30oj78AN7V_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/content-skeleton.less
// module id = CsIm
// module chunks = 24